import { action } from 'mobx';

import { AppManager, Input, routerStore } from 'core/index';

import { ProfileModel } from 'apps/profile/app';
import { UserApp } from 'apps/user/app';
import { TagsApp } from 'apps/tag/app';
import { clientStore } from 'apps/client/app';
import { SignUpMutation } from 'apps/profile/gql';

import { i18n } from 'config/i18n';

import { SignUpApp } from './app';

export class SignUpAppManager extends AppManager {
  static registryName = 'SignUpAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.signUpApp = new SignUpApp(this, {
      user: new UserApp(),
      skills: new TagsApp(),
    });
    this.signUpApp.init(init.isModal);

    const signOut = routerStore.route.name !== 'workspace.make-part.file';

    const inviteId = init?.params?.get('invite_id') || null;

    this.signUpInput = new Input({
      fullName: () => this.signUpApp.user.fullName,
      username: () => this.signUpApp.user.username.trim(),
      email: () => this.signUpApp.user.email.trim(),
      password: () => this.signUpApp.user.password,
      // emailsEnabled: () => this.signUpApp.user.emailsEnabled,
      emailsEnabled: () => true,
      preferredName: () => this.signUpApp.preferredName,
      bio: () => this.signUpApp.bio,
      intentId: () => this.signUpApp.intent,
      userTypeId: () => this.signUpApp.userType,
      skills: () =>
        this.signUpApp.skills.map(({ id, name, deleted }) => ({
          id,
          name,
          deleted,
        })),
      locale: () => i18n.language,
      startFreeTrial: () => !!init.params.get('trial'),
      encodedExtra: () => init.params.get('p'),
      inviteId,
      signOut,
    });
    const headers = {};
    if (clientStore.HMAC) headers['X-Wikifactory-Hmac'] = clientStore.HMAC;
    this.signUpMutation = new SignUpMutation(
      this.signUpInput,
      null,
      {},
      false,
      headers,
    );
    this.signUpMutation.process(profile => ProfileModel.Load(profile), null, {
      subPath: 'profile',
    });
  }

  @action SignUp = options => {
    this.signUpMutation.setCallbacks(options);
    this.signUpMutation.mutate();
  };

  @action SetProfile = profileModel => {
    clientStore.SetSignedInProfile(profileModel);
  };
}
